const SavedStructure = {
  posts: [
    {
      postId: "", // Unique Post ID
      userId: "",
      useruuid: "",
      userimage: "",
      userName: "",
      profileId: "",
      descriptions: "",
      timestamp: "", // ISO Date-Time String (e.g., "2025-03-03T12:00:00Z")
      location: "", // Location of the post
      medias: [
          {
              mediatype: "",
              mediaurl: "",
          }
      ],
    },
  ],
};

export default SavedStructure;
